import React, { useState } from "react";
import "../styles/SupportForm.css"; // Ensure your CSS file is set up

const SupportForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // New state for error message
  const [honeypot, setHoneypot] = useState(""); // Honeypot field

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormSubmitted(false);
    setErrorMessage("");

    try {
      const response = await fetch(
        "https://us-central1-craft---the-social-beer-6b1e6.cloudfunctions.net/sendGeneralEmailSupportRequest",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name, email, message }),
        }
      );

      if (response.ok) {
        console.log("Message sent successfully");
        setFormSubmitted(true);
        setName("");
        setEmail("");
        setMessage("");
      } else {
        console.log("Error sending message");
        setErrorMessage("Failed to send message. Please try again later.");
      }
    } catch (error) {
      console.error("Error during fetch operation:", error);
      setErrorMessage(`An error occurred: ${error.message}`);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="support-form">
      <h2>Need Help? Contact Us!</h2>

      {formSubmitted && (
        <div className="form-success-message">
          Thank you! Your message has been sent.
        </div>
      )}

      {errorMessage && <div className="form-error-message">{errorMessage}</div>}

      {/* Form fields remain the same */}
      <label htmlFor="name">Name:</label>
      <input
        type="text"
        id="name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />

      <label htmlFor="email">Email:</label>
      <input
        type="email"
        id="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <label htmlFor="message">Your Message:</label>
      <textarea
        id="message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        required
      />
      <div style={{ display: "none" }}>
        <label htmlFor="emailConfirm">
          Do not fill this out if you're human:
        </label>
        <input
          type="text"
          id="emailConfirm"
          name="emailConfirm"
          value={honeypot}
          onChange={(e) => setHoneypot(e.target.value)}
        />
      </div>
      <button type="submit" className="submit-button">
        Submit
      </button>
    </form>
  );
};

export default SupportForm;
